import { UadListingStatus } from '@aloft/toolkit-shared';

export const getShouldApplyListToSale = (listingStatus: UadListingStatus): boolean =>
  listingStatus === 'Active' || listingStatus === 'Contract';
